import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import { Box, Card, CardActions, CardContent, Button } from '@mui/material';
import '../styles/UploadPage.css';
import successImage from '../../../img/success_mark.png';
import SelectPhotoButton from '../../../shared/components/ui/buttons/SelectPhotoButton';
import selectPhotoButton_img1 from '../../../img/select_photo_button.png'; // 写真を撮る選ぶアイコン
import ViewAllButton from '../../../shared/components/ui/buttons/ViewAllButton';

const UploadSuccess = () => {
    const location = useLocation();
    const fromUpload = location.state?.fromUpload;
    const navigate = useNavigate();

    const handleGoToGallery = () => {
        console.log('UploadSuccess: Navigating to gallery, checking localStorage flags...');
        console.log('UploadSuccess: imageUploaded =', localStorage.getItem('imageUploaded'));
        console.log('UploadSuccess: imageUploadTimestamp =', localStorage.getItem('imageUploadTimestamp'));
        navigate('/admin/gallery');
    };

    // 🔒 location.state がない場合（直アクセス時）はログイン画面へリダイレクト
    if (!fromUpload) {
    return <Navigate to="/auth/login" replace />;
    }

    return (
        <Box className="upload-section">
            <Card
                className="upload-card"
                sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.5)', // カードの背景色
                    boxShadow: 'none',
                    color: 'rgb(100, 90, 70)',
                }}
            >
                <CardContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '8px',
                    }}
                >
                    <p className='upload-title'>Success!!</p>
                    
                    <img src={successImage} alt='sample-img' style={{ width: '60%', margin: '10% 0 10% 0' }} />
                    <p className='upload-process' style={{ fontWeight: 'bold', marginTop: '6%' }}>正常にアップロードが完了しました！</p>
                    <p className='upload-process' style={{ fontWeight: 'bold', marginBottom: '6%' }}>スクリーンをご確認ください</p>
                </CardContent>
                
                <CardActions
                    sx={{
                        padding: '8px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        gap: 2,
                    }}
                >
                    <SelectPhotoButton imageUrl={selectPhotoButton_img1} />
                </CardActions>
            </Card>
            <CardActions>
                <ViewAllButton />
            </CardActions>
        </Box>
    );
};

export default UploadSuccess;
